<template>
  <div class="module-file-uploader">
    <!-- Input oculto -->
    <input
      id="fileInput"
      type="file"
      :accept="accept"
      :multiple="multiple"
      @change="handleFiles"
      class="module-file-input"
    />

    <!-- Label estilizado como botón -->
    <label for="fileInput" class="module-file-button w-full">
      <feather-icon icon="UploadIcon" class="pr-2" />
      {{ $t('select_files') }}
    </label>

    <!-- Lista de archivos -->
    <ul v-if="files.length">
      <li v-for="(file, index) in files" :key="index" class="module-file-item">
        <span>{{ truncateText(file.name) }} ({{ formatSize(file.size) }})</span>
        <button class="module-file-remove" @click="removeFile(index)">✕</button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  accept: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  maxSize: { type: Number, default: 2 }, // MB
  maxFiles: { type: Number, default: 5 }
})

const emit = defineEmits(['update'])

const files = ref([])

const validateFileSize = (file) => {
  const sizeMB = file.size / 1024 / 1024
  return sizeMB <= props.maxSize
}

const handleFiles = (event) => {
  const inputFiles = Array.from(event.target.files)
  const selectedFiles = Array.from(inputFiles).filter(file => file.type === props.accept);
  const validFiles = selectedFiles.filter(validateFileSize)

  if (validFiles.length < selectedFiles.length) {
    window.$vs.notify({
      title: 'Alert!',
      text: `Algunos archivos exceden el tamaño máximo de ${props.maxSize} MB.`,
      color: 'warning'
    })
  }

  if (validFiles.length > props.maxFiles) {
    window.$vs.notify({
      title: 'Alert!',
      text: `Solo puedes seleccionar hasta ${props.maxFiles} archivos.`,
      color: 'warning'
    })
    files.value = validFiles.slice(0, props.maxFiles)
    console.log(files.value)
  } else {
    files.value = validFiles
  }

  emit('update', files.value)
}


const truncateText = (text, length = 40) => text.substring(0, length)


const removeFile = (index) => {
  files.value.splice(index, 1)
  emit('update', files.value)
}

const formatSize = (size) => {
  const mb = (size / 1024 / 1024).toFixed(2)
  return `${mb} MB`
}
</script>

<style scoped>
.module-file-input {
  display: none;
}

.module-file-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #BC1300;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  height: 40px;
}

.module-file-button:hover {
  background: #D51600;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.module-file-button .feather-icon {
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
}

.module-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  margin-top: 0.25rem;
}

.module-file-remove {
  background: none;
  border: none;
  color: #e53935;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.2s;
}

.module-file-remove:hover {
  color: #b71c1c;
}
</style>
